import { useMemo } from 'react';

import { useT } from '../../../../i18n';
import { soVN } from '../../../../lib/dinh-dang';
import type { KhoaDich } from '../../../../i18n';
import { llmChuaDoToken, llmTokenFox, nhanTuMau, theCau, type ChuChen, type NguonCau } from '../nghiep-vu/cau-hien-thi';
import { coMa, type MaHanhDong } from '../nghiep-vu/danh-muc';
import type { SuKien } from '../nghiep-vu/types';

/** Khoá dịch câu của một mã. Kiểu buộc catalog `vi.ts` có đủ câu cho MỌI mã của `DANH_MUC` — thiếu là lỗi `tsc`. */
function khoaCau(ma: MaHanhDong): KhoaDich {
  const khoa: `nktvDanhMuc.${MaHanhDong}` = `nktvDanhMuc.${ma}`;
  return khoa;
}

export interface BoDanhMuc {
  /** Mẫu câu của mã theo ngôn ngữ đang xem (còn placeholder), `null` khi mã chưa khai trong danh mục. */
  mau: (ma: string) => string | null;
  /**
   * Câu hiển thị đã thế placeholder, `null` khi mã chưa khai (nơi gọi hiện `nktv.cau.khongRo`, không in mã thô).
   * Lượt gọi mô hình không đo được token ra câu riêng thay vì "(trống) token".
   */
  cau: (suKien: NguonCau & Pick<SuKien, 'hanh_dong'>) => string | null;
  /** Nhãn ngắn cho ô chọn "Thao tác"; mã chưa khai thì trả chính mã. */
  nhan: (ma: string) => string;
}

/**
 * Câu và nhãn của danh mục mã hành động theo ngôn ngữ đang xem — thay `cauCho`/`nhanHanhDong` của native. Hàm thuần ở
 * `nghiep-vu/cau-hien-thi.ts`; hook này chỉ nối catalog dịch vào.
 */
export function useDanhMuc(): BoDanhMuc {
  const { t, ngonNgu } = useT();
  return useMemo(() => {
    const chu: ChuChen = { trong: t('nktv.cau.trong'), co: t('nktv.cau.co'), khong: t('nktv.cau.khong') };
    const mau = (ma: string) => (coMa(ma) ? t(khoaCau(ma)) : null);
    return {
      mau,
      cau: (suKien) => {
        const fox = llmTokenFox(suKien);
        if (fox !== null) {
          const ten = suKien.du_lieu_them?.['tinh_nang'];
          return t('nktv.cau.llmTokenFox', {
            tinhNang: typeof ten === 'string' && ten ? ten : t('nktv.cau.llmKhongRoTinhNang'),
            so: soVN(fox, ngonNgu),
          });
        }
        const tinhNang = llmChuaDoToken(suKien);
        if (tinhNang !== null) {
          return t('nktv.cau.llmChuaDoToken', { tinhNang: tinhNang || t('nktv.cau.llmKhongRoTinhNang') });
        }
        const m = mau(suKien.hanh_dong);
        return m === null ? null : theCau(m, suKien, chu);
      },
      nhan: (ma) => {
        const m = mau(ma);
        return (m === null ? null : nhanTuMau(m)) ?? ma;
      },
    };
    // `t` là hàm mới mỗi lần vẽ; câu chỉ đổi khi đổi ngôn ngữ.
  }, [ngonNgu]);
}
